import React from "react";
import { FormWatcherCallback, useAuth } from "duck";
import { useUpdateOrganizationSettingMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateTemperatureUnit = (settingsId: number) => {
  const [update] = useUpdateOrganizationSettingMutation({
    ignoreResults: true
  });
  const [, setConfig] = useAuth();

  return React.useCallback<FormWatcherCallback<FormValues>>(
    ({ temperatureUnit }) =>
      update({
        variables: {
          input: {
            _id: settingsId,
            temperatureUnit
          }
        }
      }).then(({ data }) => {
        const newTemperatureUnit =
          data?.updateOrganizationSetting?.organizationSetting?.temperatureUnit;
        if (newTemperatureUnit) {
          setConfig(prevState => {
            const newState = { ...prevState };
            if (
              newState.user.organization?.organizationSetting?.temperatureUnit
            ) {
              newState.user.organization.organizationSetting.temperatureUnit = newTemperatureUnit;
            }
            return newState;
          });
        }
      }),
    [update, settingsId]
  );
};
